import React, { Component } from 'react';
import '../../../styles/scss/style.css';

//Components
import YourPlan from './YourPlan';
import DashboardPanelMenu from '../molecules/DashboardPanelMenu';

import PageTitle2 from '../molecules/PageTitle2';

//Returning the component
class Subscription extends Component {
	render() {
		return (
			<div className="dashboardPanelContainer">
				<div className="dashboardPanel">
					<DashboardPanelMenu text='Menu' href='#' />
					<div className="dashboardPanel__content">
						<div className="dashboardPanel__mainContent">
							<PageTitle2 heading="Subscription" />
							<YourPlan currentPlan={this.props.currentPlan} features={this.props.features} renewal={this.props.renewal}/>
						</div>
					</div>
				</div>
			</div>
		)
	}
}

export default Subscription;


// WEBPACK FOOTER //
// ./src/redux/components/organisms/Subscription.jsx